import { render, staticRenderFns } from "@/modules/Vehicle/templates/vehicle-detail.html?vue&type=template&id=69159ee1&scoped=true&"
import script from "@/modules/Vehicle/scripts/vehicle-detail.ts?vue&type=script&lang=js&"
export * from "@/modules/Vehicle/scripts/vehicle-detail.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Vehicle/styles/vehicle-detail.scss?vue&type=style&index=0&id=69159ee1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69159ee1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
